import { render, staticRenderFns } from "./sonChiose.vue?vue&type=template&id=d3f80eda&scoped=true&"
import script from "./sonChiose.vue?vue&type=script&lang=js&"
export * from "./sonChiose.vue?vue&type=script&lang=js&"
import style0 from "./sonChiose.vue?vue&type=style&index=0&id=d3f80eda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f80eda",
  null
  
)

export default component.exports